module.exports = __webpack_public_path__ + "static/media/(H)_MG_6233_-_Joias_Contenporaneas.94da8812.jpg";